const CLOUD_NAME = "dfmtbntrc"
const UPLOAD_PRESET = "stgck1s3"

export async function uploadFile(file) {
    const formData = new FormData()
    formData.append('upload_preset', UPLOAD_PRESET)
    formData.append('file', file)
    return fetch(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/auto/upload`, {
        method: 'POST',
        body: formData
    })
        .then(res => res.json())
        .catch(err => console.error(err))
}
